import { cartLinkStyles } from "@insite/content-library/Widgets/Common/CartLink";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { TypographyWrapper } from "@waytek/MobiusOverrides/Link/Link";
import { colorPalette, fontFamilyAlt } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const linkProp: TypographyPresentationProps = {
    transform: "none",
    size: 16,
    weight: 400,
    fontFamily: fontFamilyAlt,
};

if (cartLinkStyles.routerLink) {
    cartLinkStyles.routerLink!.hoverStyle = {
        ...cartLinkStyles.routerLink?.hoverStyle,
        color: colorPalette.common.global.white,
        textDecoration: "underline",
    };

    cartLinkStyles.routerLink!.css = css`
        ${cartLinkStyles.routerLink?.css}
        padding: 0;
        position: relative;

        &&&& {
            ${TypographyWrapper} {
                text-decoration: none;

                ${TypographyStyle} {
                    border-bottom: 0;
                }

                &:hover {
                    border-bottom: 0;
                }
            }
        }
    `;

    cartLinkStyles.routerLink!.icon = {
        ...cartLinkStyles.routerLink!.icon,
        iconProps: {
            ...cartLinkStyles.routerLink!.icon?.iconProps,
            size: 30,
        },
    };

    cartLinkStyles.routerLink!.typographyProps = {
        ...cartLinkStyles.routerLink?.typographyProps,
        ...linkProp,
    };
}
